export default __webpack_public_path__ + "static/media/phone-icon.ab463ad9.svg";